const listeners = new Set();
let activeId = null;

export function getActiveVoiceMessageId() {
  return activeId;
}

export function setActiveVoiceMessageId(id) {
  if (id === activeId) return;
  activeId = id;
  listeners.forEach(l => {
    try {
      l(id);
    } catch {
      /* ignore */
    }
  });
}

export function subscribeActiveVoiceMessage(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
